var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.817 4.4591C10.7363 4.32002 10.618 4.20407 10.4743 4.12333C10.3306 4.04259 10.1668 4 10 4C9.83317 4 9.66938 4.04259 9.5257 4.12333C9.38201 4.20407 9.26368 4.32002 9.18301 4.4591L3.11626 15.1259C3.03781 15.2612 2.99777 15.4137 3.0001 15.5683C3.00242 15.7228 3.04703 15.8742 3.12952 16.0073C3.21201 16.1404 3.32954 16.2508 3.47048 16.3274C3.61143 16.4041 3.77094 16.4444 3.93325 16.4444H16.0667C16.2291 16.4444 16.3886 16.4041 16.5295 16.3274C16.6705 16.2508 16.788 16.1404 16.8705 16.0073C16.953 15.8742 16.9976 15.7228 16.9999 15.5683C17.0022 15.4137 16.9622 15.2612 16.8837 15.1259L10.817 4.4591Z",
    fill: "#EB5757",
    stroke: "#EB5757",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.541C10.055 13.541 10.1078 13.5629 10.1467 13.6018C10.1856 13.6407 10.2074 13.6934 10.2074 13.7484",
    stroke: "#EB5757",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79272 13.7484C9.79272 13.6934 9.81458 13.6407 9.85347 13.6018C9.89237 13.5629 9.94512 13.541 10.0001 13.541",
    stroke: "#EB5757",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 13.9555C9.94512 13.9555 9.89237 13.9336 9.85347 13.8947C9.81458 13.8558 9.79272 13.8031 9.79272 13.748",
    stroke: "#EB5757",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2074 13.748C10.2074 13.8031 10.1856 13.8558 10.1467 13.8947C10.1078 13.9336 10.055 13.9555 10 13.9555",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.9998L10 7.88867",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.4528a60cbeb81b45dd0d141b1710b12a.svg";
export { ForwardRef as ReactComponent };